import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-facture-clt-ticket-caisse',
  templateUrl: './facture-clt-ticket-caisse.component.html',
  styleUrls: ['./facture-clt-ticket-caisse.component.scss']
})
export class FactureCltTicketCaisseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
